import { CheckListModalList } from '@typeRoots/common/checkListModal';

export const operationsList: CheckListModalList = {
  AutomobileLiability: [{ name: 'Automobile Liability', value: 'automobile_liability' }],
  AutomobilePhysicalDamage: [
    { name: 'Automobile Physical Damage', value: 'automobile_physical_damage' },
  ],
  MotorTruckCargo: [{ name: 'Motor Truck Cargo', value: 'motor_truck_cargo' }],
  GeneralLiability: [{ name: 'General Liability', value: 'general_liability' }],
  NonTruckingLiability: [{ name: 'Non-Trucking Liability', value: 'non_trucking_liability' }],
};
